import { createApplier } from '@/app/libs/I';

/**
 * @deprecated legacy
 */
export namespace dateService {
  export const applierId = Symbol('date-service');
  export const apply = createApplier(applierId);
}
